export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["UNKNOWN_LOCATION_TYPE"] = "UNKNOWN_LOCATION_TYPE";
    /** A business location, either the default business address, or locations defined for the business by the Business Info. */
    LocationLocationType["BUSINESS"] = "BUSINESS";
    /** The location is unique to this service and isn't defined as one of the business locations. */
    LocationLocationType["CUSTOM"] = "CUSTOM";
    /** The location can be determined by the customer and is not set up beforehand. */
    LocationLocationType["CUSTOMER"] = "CUSTOMER";
})(LocationLocationType || (LocationLocationType = {}));
//# sourceMappingURL=types.impl.js.map